import { Component, OnInit, OnDestroy, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsuarioService } from '../../../services/usuario.service';
import * as L from 'leaflet';
import 'leaflet-polylinedecorator';
import { ControllAppService } from '../../../../../services/controllApp.service';
import { UsuarioResponseDto } from '../../../models/usuario.response.dto';
import { environment } from '../../../../../../environments/environment';
import { IconManagerService } from '../../../services/icon-manager.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CriarRecadastramentoResponseDto } from '../../../../colaborador/models/Criar.Recadastramento.Response.Dto';
import { CriarCadastroResponseDtoAdmin } from '../../../models/Criar.Cadastro.Response.Dto';
import { finalize } from 'rxjs/operators';

import { RoteiroUsuarioService } from '../../../services/roteiro-usuario.service';
import { formularioService } from '../../../../colaborador/services/formulario.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AuthService } from '../../../../../services/auth.service';
import { Localizacao } from './localizacao.model';
import { ServicoService } from '../../../services/servico.service';
import { DispositivoDto } from '../../../../../services/controllApp.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-roteiro-colaborador',
  standalone: false,
  templateUrl: './roteiro-colaborador.component.html',
  styleUrl: './roteiro-colaborador.component.css'
})
export class RoteiroColaboradorComponent implements OnInit, OnDestroy, OnChanges {
  getNivelBateriaNum(disp: any): number {
    const val = disp?.nivelBateria;
    const num = Number(val);
    return isNaN(num) ? 0 : num;
  }

  paginaAtualRegistros: number = 1;
  tamanhoPaginaRegistros: number = 100;
  totalPaginasRegistros: number = 1;
  totalItensRegistros: number = 0;
  rotacaoFoto = 0;
  filtroUsuarioId: string = '';
  filtroDataInicio: string = '';
  filtroDataFim: string = '';
  // Filtro de status para tabela/exportação (vazio = todos)
  filtroStatus: string = '';
  usuariosFiltro: { usuarioId: string, nome: string }[] = [];
  filtroAplicado: boolean = false; 
  private pendingCadastroId: string | null = null;
  private pendingRecadastroId: string | null = null;
  private pendingIdJuncao: string | null = null;
  userData: UsuarioResponseDto | null = null;
  nomeUsuario: string = '';
  nomeDaEmpresa: string = '';
  isOnline: boolean = false;
  private refreshInterval: any;
  totalCadastros: number = 0;
  realizadosCadastros: number = 0;
  totalRecadastros: number = 0;
  realizadosRecadastros: number = 0;
  // Novos contadores por status para cadastros e recadastramentos
  cadastroConcluida: number = 0; // status = 'Pendente' && statusOS = 'Concluida'
  cadastroRetornar: number = 0;  // status = 'Ausente' && statusOS = 'Retornar'
  cadastroNegada: number = 0;    // status = 'Negado' && statusOS = 'Negada'

  recadastroConcluida: number = 0;
  recadastroRetornar: number = 0;
  recadastroNegada: number = 0;

  // Contador combinado: cadastros + recadastros com status = 'Pendente' && statusOS = 'Pendente'
  pendingBothCount: number = 0;
  // Totais agrupados que serão exibidos nos 2 cards principais
  cadastroStatusTotal: number = 0;
  recadastroStatusTotal: number = 0;

  get totalVistorias(): number {
    return this.totalCadastros + this.totalRecadastros;
  }

  rotacoesMiniatura: { [url: string]: number } = {};

  getRotacaoMiniatura(url: string): number {
    const key = this.getFotoRotacaoKey(url);
    if (this.rotacoesMiniatura[key] !== undefined) return this.rotacoesMiniatura[key];
    const rotacaoSalva = localStorage.getItem(key);
    return rotacaoSalva ? parseInt(rotacaoSalva, 10) : 0;
  }

  girarMiniatura(url: string, direcao: 'esquerda' | 'direita'): void {
    const key = this.getFotoRotacaoKey(url);
    let rot = this.getRotacaoMiniatura(url);
    rot += direcao === 'esquerda' ? -90 : 90;
    rot = ((rot % 360) + 360) % 360;
    this.rotacoesMiniatura[key] = rot;
    // Salva automaticamente ao girar
    localStorage.setItem(key, rot.toString());
    // Força detecção de mudança
    this.cdr.markForCheck();
  }
  private photoRotations: { [key: string]: number } = {};
  rotatePhoto(url: string | undefined, delta: number): void {
    if (!url) return;
    const key = url;
    const current = this.photoRotations[key] || 0;
    const normalized = Math.round(delta / 90) * 90;
    let next = (current + normalized) % 360;
    if (next < 0) next += 360;
    this.photoRotations[key] = next;
  }

  abrirModalFoto(url: string): void {
    this.fotoSelecionada = url;
    this.mostrarModalFoto = true;

    const key = this.getFotoRotacaoKey(url);
    if (this.rotacoesMiniatura[key] === undefined) {

      this.rotacoesMiniatura[key] = this.getRotacaoMiniatura(url);
    }
    this.rotacaoFoto = this.rotacoesMiniatura[key];
  }

  fecharModalFoto(): void {
    this.mostrarModalFoto = false;
    this.fotoSelecionada = '';
    this.rotacaoFoto = 0;
  }
  salvarRotacaoFoto(): void {
    if (!this.fotoSelecionada) return;
    const key = this.getFotoRotacaoKey(this.fotoSelecionada);
    localStorage.setItem(key, this.rotacaoFoto.toString());
  }
  
  excluirFoto(foto: any): void {
    if (!foto) return;
    const id = String(foto.fotoId || foto.id || foto.foto?.id || foto.idFoto || '');
    if (!id) {
      Swal.fire('Erro', 'Não foi possível identificar o ID da foto para exclusão.', 'error');
      return;
    }

    Swal.fire({
      title: 'Confirma exclusão desta foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({
        title: 'Excluindo...',
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); },
        showConfirmButton: false
      });
      this.formularioService.excluirFoto(id).subscribe({
        next: () => {
          try {
            const url = foto.url || foto.path || '';
            if (url) {
              const key = this.getFotoRotacaoKey(url);
              localStorage.removeItem(key);
            }
            if (this.CadastroSelecionado && Array.isArray(this.CadastroSelecionado.fotos)) {
              this.CadastroSelecionado.fotos = this.CadastroSelecionado.fotos.filter((f: any) => {
                const fid = String(f.fotoId || f.id || f.foto?.id || f.idFoto || '');
                return fid !== id;
              });
            }
          } catch (e) { /* ignore */ }
          Swal.close();
          this.cdr.markForCheck();
          Swal.fire('Excluída', 'Foto excluída com sucesso.', 'success');
        },
        error: (err) => {
          console.error('Erro ao excluir foto:', err);
          Swal.close();
          Swal.fire('Erro', 'Erro ao excluir foto.', 'error');
          this.cdr.markForCheck();
        }
      });
    });
  }

  excluirFotoDocumento(fotoDoc: any): void {
    if (!fotoDoc) return;
    const id = String(fotoDoc.fotoDocumentoId || fotoDoc.id || fotoDoc.idDocumento || fotoDoc.foto?.id || '');
    if (!id) {
      Swal.fire('Erro', 'Não foi possível identificar o ID do documento para exclusão.', 'error');
      return;
    }

    Swal.fire({
      title: 'Confirma exclusão deste documento/foto?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
      if (!result.isConfirmed) return;
      Swal.fire({
        title: 'Excluindo...',
        allowOutsideClick: false,
        didOpen: () => { Swal.showLoading(); },
        showConfirmButton: false
      });
      this.formularioService.excluirFotosDocumento(id).subscribe({
        next: () => {
          try {
            const url = fotoDoc.url || fotoDoc.path || '';
            if (url) {
              const key = this.getFotoRotacaoKey(url);
              localStorage.removeItem(key);
            }
            if (this.CadastroSelecionado && Array.isArray(this.CadastroSelecionado.fotosDocumento)) {
              this.CadastroSelecionado.fotosDocumento = this.CadastroSelecionado.fotosDocumento.filter((d: any) => {
                const did = String(d.fotoDocumentoId || d.id || d.idDocumento || d.foto?.id || '');
                return did !== id;
              });
            }
          } catch (e) { /* ignore */ }
          Swal.close();
          this.cdr.markForCheck();
          Swal.fire('Excluído', 'Documento excluído com sucesso.', 'success');
        },
        error: (err) => {
          console.error('Erro ao excluir documento:', err);
          Swal.close();
          Swal.fire('Erro', 'Erro ao excluir documento.', 'error');
          this.cdr.markForCheck();
        }
      });
    });
  }
  getFotoRotacaoKey(url: string): string {
    return 'foto_rotacao_' + btoa(encodeURIComponent(url));
  }

  girarFoto(direcao: 'esquerda' | 'direita'): void {
    if (direcao === 'esquerda') {
      this.rotacaoFoto -= 90;
    } else {
      this.rotacaoFoto += 90;
    }
    // Manter o ângulo entre 0 e 360
    this.rotacaoFoto = ((this.rotacaoFoto % 360) + 360) % 360;
    
    // Salva automaticamente a rotação no localStorage e no objeto
    if (this.fotoSelecionada) {
      const key = this.getFotoRotacaoKey(this.fotoSelecionada);
      this.rotacoesMiniatura[key] = this.rotacaoFoto;
      localStorage.setItem(key, this.rotacaoFoto.toString());
    }
  }
  // Removido: salvarRotacaoMiniatura (não é mais necessário)
  getFullImageUrl(url: string): string {
    if (!url) return '';
    if (/^https?:\/\//.test(url)) return url;
    return environment.mediaUrl.replace(/\/$/, '') + (url.startsWith('/') ? url : '/' + url);
  }

  // Try to auto-open a cadastro/recadastro if navigation provided an id in query params
  private tryAutoOpenPending(): void {
    // prefer idJuncao if available
    if (this.pendingIdJuncao) {
      this.servicoService.obterDetalhesporIdJuncao(this.pendingIdJuncao).subscribe(detalhes => {
        if (detalhes) {
          let item: any = null;
          if (detalhes.recadastroId) {
            item = { ...detalhes, tipo: 'recadastro', recadastroId: detalhes.recadastroId };
          } else if (detalhes.cadastroId) {
            item = { ...detalhes, tipo: 'cadastro', cadastroId: detalhes.cadastroId };
          }
          if (item) {
            this.abrirFormulario(item);
          }
        }
        this.pendingIdJuncao = null;
      }, err => {
        console.error('Erro ao obter detalhes por idJuncao para auto-open', err);
        this.pendingIdJuncao = null;
      });
      return;
    }

    // prefer recadastro
    if (this.pendingRecadastroId) {
      const found = this.registrosUnificados.find(r => (r as any).recadastroId === this.pendingRecadastroId);
      if (found) {
        this.abrirFormulario(found as any);
        this.pendingRecadastroId = null;
        return;
      }
      // fetch by id and open
      this.servicoService.obterRecadastroPorId(this.pendingRecadastroId).subscribe(rc => {
        if (rc) {
          const item = { ...rc, tipo: 'recadastro' } as any;
          this.abrirFormulario(item);
        }
        this.pendingRecadastroId = null;
      }, err => {
        console.error('Erro ao obter recadastro para auto-open', err);
        this.pendingRecadastroId = null;
      });
      return;
    }

    if (this.pendingCadastroId) {
      const found = this.registrosUnificados.find(r => (r as any).cadastroId === this.pendingCadastroId || (r as any).id === this.pendingCadastroId);
      if (found) {
        this.abrirFormulario(found as any);
        this.pendingCadastroId = null;
        return;
      }
      this.servicoService.obterCadastroPorId(this.pendingCadastroId).subscribe(cd => {
        if (cd) {
          const item = { ...cd, tipo: 'cadastro' } as any;
          this.abrirFormulario(item);
        }
        this.pendingCadastroId = null;
      }, err => {
        console.error('Erro ao obter cadastro para auto-open', err);
        this.pendingCadastroId = null;
      });
    }
  }

  get realizadas(): number {
    return this.realizadosCadastros + this.realizadosRecadastros;
  }

  // Getter para registros da página atual
  get registrosPaginaAtual(): (CriarRecadastramentoResponseDto & { tipo: string })[] {
    const inicio = (this.paginaAtualRegistros - 1) * this.tamanhoPaginaRegistros;
    const fim = inicio + this.tamanhoPaginaRegistros;
    return (this.registrosFiltrados || []).slice(inicio, fim);
  }

  tempoMedioExecucao: string = '00:00:00';

  // Date filter
  dataSelecionada: string = '';
  hoje: string = new Date().toISOString().split('T')[0];

  // Maps
  private mapUserLocation!: L.Map;
  private mapShiftLocation!: L.Map;
  private currentMarker?: L.Marker;
  private routePolyline?: L.Polyline;
  private shiftMarkers: L.Marker[] = [];
  private shiftPolylines: L.Polyline[] = [];

  // Location history tracking
  private locationHistory: {
    lat: number;
    lng: number;
    timestamp: Date;
    isOnline: boolean;
  }[] = [];
  private locationTrailPolyline?: L.Polyline;
  private lastKnownLat?: number;
  private lastKnownLng?: number;

  // User data
  rotas: any[] = [];
  locaisInicioExecucao: any[] = [];

  // New properties
  CadastroSelecionado: (CriarCadastroResponseDtoAdmin & { tipo?: string }) | null = null;
  mostrarFormulario: boolean = false;
  fotoPerfil: string = ''; // URL for the profile photo

  // Add new property for the vistoria map
  private mapCadastro: L.Map | null = null;

  isLoadingMap: boolean = false;

  // Add property for cadastros data
  cadastrosDoDia: CriarRecadastramentoResponseDto[] = [];
  recadastramentosDoDia: CriarRecadastramentoResponseDto[] = [];

  // Adicionar propriedade para armazenar registros unificados
  registrosUnificados: (CriarRecadastramentoResponseDto & { tipo: string })[] = [];

  /** Retorna registros aplicando o filtro de status (se definido). */
  get registrosFiltrados(): (CriarRecadastramentoResponseDto & { tipo: string })[] {
    if (!this.filtroStatus) return this.registrosUnificados || [];
    const filtro = this.filtroStatus.toString().toLowerCase();
    return (this.registrosUnificados || []).filter(r => {
      const statusRaw = (r && (r.statusOS || r.status )) ? String(r.statusOS) : '';
      const s = statusRaw.toLowerCase();
      return s.indexOf(filtro) !== -1;
    });
  }

  // Add rate limiting properties
  private routeRequestQueue: Array<() => void> = [];
  private isProcessingRoutes: boolean = false;
  private routeRequestDelay: number = 1000; // 1 second between requests

  // Adicionar estas propriedades na classe 
  mostrarModalFoto = false;
  fotoSelecionada = '';

  // Novas propriedades para o filtro de dia no mapa
  datasDisponiveisMapa: string[] = [];
  dataSelecionadaMapa: string = '';

  dispositivosUsuario: DispositivoDto[] = [];

  constructor(
    private usuarioService: UsuarioService,
    private route: ActivatedRoute,
    private controllAppService: ControllAppService,
    private iconManagerService: IconManagerService,
    private spinner: NgxSpinnerService,
    private servicoService: ServicoService,
    private roteiroUsuarioService: RoteiroUsuarioService,
    private formularioService: formularioService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) { }

  get isSuperAdministrador(): boolean {
    try {
      return this.authService.isSuperAdmin();
    } catch (e) {
      return false;
    }
  }

  ngOnInit(): void {
    // Lógica original do filtro
    this.filtroDataFim = this.getDataHojeInput();
    this.filtroDataInicio = this.getDataSeteDiasAtrasInput();

    // Verificar se há query parameters (usuarioId, cadastroId, recadastroId)
    this.route.queryParams.subscribe(params => {
      let mudouData = false;
      if (params['filtroDataInicio']) {
        let data = params['filtroDataInicio'];
        // Aceita formatos com T ou barra
        if (data.includes('T')) data = data.split('T')[0];
        if (data.includes('/')) {
          // dd/MM/yyyy para yyyy-MM-dd
          const [d, m, y] = data.split('/');
          data = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        this.filtroDataInicio = data;
        mudouData = true;
      }
      if (params['filtroDataFim']) {
        let data = params['filtroDataFim'];
        if (data.includes('T')) data = data.split('T')[0];
        if (data.includes('/')) {
          const [d, m, y] = data.split('/');
          data = `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
        }
        this.filtroDataFim = data;
        mudouData = true;
      }

      if (params['usuarioId']) {
        this.filtroUsuarioId = params['usuarioId'];
        // Se há um usuário selecionado, inicializar os mapas e carregar dados
        this.aplicarFiltroAutomatico();
      }

      if (params['cadastroId']) {
        this.pendingCadastroId = params['cadastroId'];
      }
      if (params['recadastroId']) {
        this.pendingRecadastroId = params['recadastroId'];
      }
      if (params['idJuncao']) {
        this.pendingIdJuncao = params['idJuncao'];
      }

      // Força atualização visual dos campos de data
      if (mudouData) {
        this.cdr.detectChanges();
      }
    });

    this.usuarioService.carregarTodosColaboradores().subscribe({
      next: (colaboradores) => {
        this.usuariosFiltro = (colaboradores || [])
          .map((u: any) => ({ usuarioId: u.usuarioId, nome: u.nome }))
          .filter(u => !!u.usuarioId && !!u.nome);
      },
      error: () => {
        this.usuariosFiltro = [];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filtroUsuarioId'] && changes['filtroUsuarioId'].currentValue) {
      // Recarrega dados ao trocar o usuário
      this.inicializarHistorico();
    }
    if ((changes['filtroDataInicio'] && changes['filtroDataInicio'].currentValue) ||
      (changes['filtroDataFim'] && changes['filtroDataFim'].currentValue)) {
      // Atualiza as datas selecionadas quando receber novas datas
      if (this.filtroDataInicio) {
        this.dataSelecionada = this.filtroDataInicio;
      }
      // Recarrega dados ao trocar as datas
      if (this.filtroUsuarioId) {
        this.carregarCadastrosDoDia();
      }
    }
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    // Clear route request queue
    this.routeRequestQueue = [];
    this.isProcessingRoutes = false;

    // Clean up maps to prevent memory leaks
    if (this.mapUserLocation) {
      this.mapUserLocation.remove();
    }
    if (this.mapShiftLocation) {
      this.mapShiftLocation.remove();
    }
    // Also clean up the vistoria map if it exists
    if (this.mapCadastro) {
      this.mapCadastro.remove();
    }
  }
  // Retorna um valor de exibição para o número da OS (faz fallback por vários nomes comuns)
  formatNumeroOS(servico: any): string {
    if (!servico) return '-';
    const candidato = servico.numeroOS || servico.numeroOs || servico.numeroOrdem || servico.numero || servico.ordemNumero || servico.numeroOrdemFormatado || servico.osNumero || servico.osNumero1 || servico.osNumero2 || servico.osNumero3;
    if (!candidato && candidato !== 0) return '-';
    const s = candidato.toString();
    // Se já contém zeros à esquerda ou possui formatação não-numérica, devolve como está
    if (/[^0-9]/.test(s) || /^0+/.test(s)) return s;
    // Pad para 4 dígitos (ex: 14 -> 0014)
    return s.padStart(4, '0');
  }

  private inicializarHistorico() {
    if (!this.filtroUsuarioId) return;

    // Aguarde o DOM estar pronto
    this.waitForMapsElements().then(() => {
      this.initializeMaps();
      this.loadUserDetails(this.filtroUsuarioId);
      this.carregarCadastrosDoDia();

      // Alterar o intervalo de atualização para 10 minutos (600000ms)
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
      this.refreshInterval = setInterval(() => {
        this.loadUserDetails(this.filtroUsuarioId);
        this.carregarCadastrosDoDia();
      }, 600000); // 10 minutos

      this.loadUserData();
      // Carregar dispositivos do usuário
      this.carregarDispositivosUsuario();
    });
  }

  carregarDispositivosUsuario() {
    if (!this.filtroUsuarioId) {
      this.dispositivosUsuario = [];
      return;
    }

    // Usar o endpoint de histórico e extrair apenas o registro mais recente
    this.controllAppService.buscarHistoricoDispositivoPorUsuarioId(this.filtroUsuarioId).subscribe({
      next: (res: any) => {
        try {
          const latestEntries: DispositivoDto[] = [];

          // Caso a API retorne um array de dispositivos com historicos
          if (Array.isArray(res)) {
            for (const item of res) {
              if (item && Array.isArray(item.historicos) && item.historicos.length > 0) {
                const latest = item.historicos.reduce((a: any, b: any) => {
                  const ta = a?.dataAtualizacao ? new Date(a.dataAtualizacao).getTime() : 0;
                  const tb = b?.dataAtualizacao ? new Date(b.dataAtualizacao).getTime() : 0;
                  return tb > ta ? b : a;
                });
                latestEntries.push(latest as DispositivoDto);
              } else if (item && item.dataAtualizacao) {
                // fallback: já é um DispositivoDto
                latestEntries.push(item as DispositivoDto);
              }
            }
          } else if (res && typeof res === 'object') {
            // Caso a API retorne um único objeto com campo historicos
            if (Array.isArray(res.historicos) && res.historicos.length > 0) {
              const latest = res.historicos.reduce((a: any, b: any) => {
                const ta = a?.dataAtualizacao ? new Date(a.dataAtualizacao).getTime() : 0;
                const tb = b?.dataAtualizacao ? new Date(b.dataAtualizacao).getTime() : 0;
                return tb > ta ? b : a;
              });
              latestEntries.push(latest as DispositivoDto);
            } else if (res.dataAtualizacao) {
              // fallback: o objeto já é um DispositivoDto
              latestEntries.push(res as DispositivoDto);
            }
          }

          this.dispositivosUsuario = latestEntries;
        } catch (err) {
          console.error('Erro ao processar histórico de dispositivos:', err);
          this.dispositivosUsuario = [];
        }
      },
      error: (err) => {
        console.error('Erro ao buscar histórico de dispositivos:', err);
        this.dispositivosUsuario = [];
      }
    });
  }

  aplicarFiltro(): void {

    // Se há um usuário selecionado, inicializar/atualizar o histórico
    if (this.filtroUsuarioId) {
      this.filtroAplicado = true;
      this.inicializarHistorico();
    } else {
      this.filtroAplicado = false;
    }
  }

  // Novo método para aplicar o filtro automaticamente quando o usuário é selecionado
  aplicarFiltroAutomatico(): void {
    // Verifica se tem usuário selecionado
    if (this.filtroUsuarioId) {
      if (!this.filtroDataFim) this.filtroDataFim = this.getDataHojeInput();
      if (!this.filtroDataInicio) this.filtroDataInicio = this.getDataSeteDiasAtrasInput();

      // Aplica o filtro e recarrega mapas
      this.aplicarFiltro();
      // Chama imediatamente o método para buscar dispositivos
      this.carregarDispositivosUsuario();
    } else {
      this.filtroAplicado = false;
    }
  }

  resetarFiltro(): void {
    this.filtroUsuarioId = '';
    this.filtroDataFim = this.getDataHojeInput();
    this.filtroDataInicio = this.getDataSeteDiasAtrasInput();
    this.filtroAplicado = false;
    this.dispositivosUsuario = [];
  }

  getDataHojeInput(): string {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  }

  getDataSeteDiasAtrasInput(): string {
    const hoje = new Date();
    const seteDiasAtras = new Date(hoje);
    seteDiasAtras.setDate(hoje.getDate() - 0);
    return seteDiasAtras.toISOString().split('T')[0];
  }

  // ===== MÉTODOS DO HISTÓRICO INTEGRADOS =====

  private loadUserDetails(id: string) {
    this.controllAppService.usuarioGetById(id).subscribe({
      next: (user) => {
        this.userData = user;
        this.nomeUsuario = user.nome || 'Nome não disponível';
        this.nomeDaEmpresa = this.getEmpresaNome(user.empresa);
        this.isOnline = user.isOnline || false;

        if (user.latitudeAtual && user.longitudeAtual) {
          const lat = parseFloat(user.latitudeAtual);
          const lng = parseFloat(user.longitudeAtual);

          this.updateUserLocationOnMap(lat, lng);

          this.updateLocationHistory(lat, lng, this.isOnline);
        }

        this.displayUserLocationsForDate(user);
      },
      error: (error) => {
        console.error('Error loading user details:', error);
      }
    });
  }

  private updateLocationHistory(lat: number, lng: number, isOnline: boolean) {
    if (isNaN(lat) || isNaN(lng)) return;

    const isFirst = this.locationHistory.length === 0;
    const hasChanged =
      this.lastKnownLat === undefined ||
      this.lastKnownLng === undefined ||
      Math.abs(this.lastKnownLat - lat) > 0.0001 ||
      Math.abs(this.lastKnownLng - lng) > 0.0001;

    if (isFirst || hasChanged) {
      this.lastKnownLat = lat;
      this.lastKnownLng = lng;

      this.locationHistory.push({
        lat,
        lng,
        timestamp: new Date(),
        isOnline
      });

      if (this.locationHistory.length > 50) {
        this.locationHistory.shift();
      }

      this.updateLocationTrail();
    }
  }

  private generateMarkerSvg(position: number): string {
    const fillColor = '#2A81CB'; // azul típico do Leaflet Routing Machine
    const textColor = '#ffffff';

    return `
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" viewBox="0 0 36 50">
        <!-- Gota azul -->
        <path d="M18,0 C28,0 36,8 36,18 C36,31 18,50 18,50 C18,50 0,31 0,18 C0,8 8,0 18,0 Z" fill="${fillColor}" />
        
        <!-- Número branco no centro -->
        <text x="18" y="26" text-anchor="middle" fill="${textColor}" font-size="16" font-family="Arial" font-weight="bold">${position}</text>
      </svg>
    `.trim();
  }

  private updateLocationTrail() {
    if (!this.mapShiftLocation) return;

    // Remove marcadores antigos
    this.shiftMarkers.forEach(marker => this.mapShiftLocation.removeLayer(marker));
    this.shiftMarkers = [];

    // Remove polyline antiga, se existir
    if (this.locationTrailPolyline) {
      this.mapShiftLocation.removeLayer(this.locationTrailPolyline);
      this.locationTrailPolyline = undefined;
    }

    if (this.locationHistory.length > 0) {
      const points = this.locationHistory.map(pos => [pos.lat, pos.lng]);
      this.locationTrailPolyline = L.polyline(points as L.LatLngExpression[], {
        color: '#3388ff',
        weight: 3,
        opacity: 0.7
      }).addTo(this.mapShiftLocation);

      this.locationHistory.forEach((pos, index) => {

        const icon = L.divIcon({
          className: '',
          html: this.generateMarkerSvg(index + 1),
          iconSize: [36, 50],
          iconAnchor: [18, 50],
          popupAnchor: [0, -45]
        });

        const marker = L.marker([pos.lat, pos.lng], {
          icon,
          title: `Posição ${index + 1}`
        }).addTo(this.mapShiftLocation);

        const timeFormatted = pos.timestamp.toLocaleTimeString();

        marker.bindPopup(`
          <strong>Registro ${index + 1}</strong><br>
          Hora: ${timeFormatted}<br>
          Coord: ${pos.lat.toFixed(6)}, ${pos.lng.toFixed(6)}
        `);

        this.shiftMarkers.push(marker);
      });

      this.mapShiftLocation.fitBounds(this.locationTrailPolyline.getBounds(), {
        padding: [30, 30]
      });
    }
  }

  private updateUserLocationOnMap(lat: number, lng: number) {
    if (!this.mapUserLocation) return;

    if (this.currentMarker) {
      this.mapUserLocation.removeLayer(this.currentMarker);
    }

    // Use online status to determine the icon instead of company
    const isOnline = this.userData?.isOnline || false;
    const icon = this.iconManagerService.getLeafletIconByStatus(isOnline);

    this.currentMarker = L.marker([lat, lng], { icon }).addTo(this.mapUserLocation);

    // Formatar a data corretamente para o fuso horário brasileiro
    const lastLoginDate = this.userData?.dataHoraUltimaAutenticacao
      ? new Date(this.userData.dataHoraUltimaAutenticacao)
      : null;

    const lastLoginText = lastLoginDate
      ? lastLoginDate.toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      : 'Data não disponível';

    const locationDate = this.userData?.dataEHoraLocalizacao
      ? new Date(this.userData.dataEHoraLocalizacao)
      : null;

    const locationText = locationDate
      ? locationDate.toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
      : 'Data não disponível';

    const statusText = isOnline ? '<span style="color:#4CAF50">Online</span>' : '<span style="color:#f44336">Offline</span>';

    const popupContent = `
      <div style="font-family: Arial, sans-serif; max-width: 250px;">
        <div style="text-align: center; margin-bottom: 10px;">
          <strong style="font-size: 16px;">${this.nomeUsuario}</strong><br>
          <span style="color: #666; font-size: 14px;">${this.nomeDaEmpresa}</span><br>
          <span style="margin-top: 5px; display: inline-block;">Status: ${statusText}</span>
        </div>
        <hr style="border: none; border-top: 1px solid #ddd; margin: 10px 0;">
        <div style="text-align: left;">
          <div style="margin-bottom: 8px;">
            <strong>Último Login:</strong><br>
            <span style="font-size: 12px; color: #555;">${lastLoginText}</span>
          </div>
          <div>
            <strong>Última Localização:</strong><br>
            <span style="font-size: 12px; color: #555;">${locationText}</span>
          </div>
        </div>
      </div>
    `;

    this.currentMarker.bindPopup(popupContent);
    this.currentMarker.openPopup();
    this.mapUserLocation.setView([lat, lng], 15);
  }

  verMinhaLocalizacao() {
    if (this.userData?.latitudeAtual && this.userData?.longitudeAtual) {
      const lat = parseFloat(this.userData.latitudeAtual);
      const lng = parseFloat(this.userData.longitudeAtual);
      this.updateUserLocationOnMap(lat, lng);
    } else {
      alert('Localização do usuário não disponível.');
    }
  }

  private waitForMapsElements(): Promise<void> {
    return new Promise((resolve) => {
      const checkElements = () => {
        const mapUserElement = document.getElementById('mapUserLocation');
        const mapShiftElement = document.getElementById('mapShiftLocation');

        if (mapUserElement && mapShiftElement) {
          resolve();
        } else {
          setTimeout(checkElements, 100);
        }
      };
      checkElements();
    });
  }

  private initializeMaps() {
    try {
      // Remove instâncias anteriores dos mapas para garantir recriação
      if (this.mapUserLocation) {
        this.mapUserLocation.remove();
        this.mapUserLocation = undefined as any;
      }
      if (this.mapShiftLocation) {
        this.mapShiftLocation.remove();
        this.mapShiftLocation = undefined as any;
      }

      this.mapUserLocation = L.map('mapUserLocation', {
        center: [-22.9068, -43.1729],
        zoom: 13
      });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(this.mapUserLocation);

      this.mapShiftLocation = L.map('mapShiftLocation', {
        center: [-22.9068, -43.1729],
        zoom: 13
      });
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(this.mapShiftLocation);

      // Forçar atualização do tamanho dos mapas
      setTimeout(() => {
        if (this.mapUserLocation) this.mapUserLocation.invalidateSize();
        if (this.mapShiftLocation) this.mapShiftLocation.invalidateSize();
      }, 100);
    } catch (error) {
      console.error('Erro ao inicializar mapas:', error);
    }
  }

  private recarregarDados() {
    if (!this.mapUserLocation || !this.mapShiftLocation) {
      console.error('Maps not initialized');
      return;
    }

    this.clearMapLayers();

    this.locationHistory = [];
    this.lastKnownLat = undefined;
    this.lastKnownLng = undefined;

    if (this.userData) {
      this.displayUserLocationsForDate(this.userData);
    }

    this.carregarCadastrosDoDia();
  }

  private clearMapLayers() {

    if (this.routePolyline) {
      this.mapUserLocation.removeLayer(this.routePolyline);
      this.routePolyline = undefined;
    }

    // Remove o trail de localização
    if (this.locationTrailPolyline) {
      this.mapShiftLocation.removeLayer(this.locationTrailPolyline);
      this.locationTrailPolyline = undefined;
    }

    // Clear shift markers
    this.shiftMarkers.forEach(marker => this.mapShiftLocation.removeLayer(marker));
    this.shiftMarkers = [];

    // Clear shift polylines
    if (this.shiftPolylines && this.shiftPolylines.length) {
      this.shiftPolylines.forEach(polyline => this.mapShiftLocation.removeLayer(polyline));
      this.shiftPolylines = [];
    }
  }

  private carregarCadastrosDoDia() {
    this.spinner.show();

    const dataInicio = this.filtroDataInicio;
    const dataFim = this.filtroDataFim;
    const usuarioId = this.filtroUsuarioId;

    // Reset the data before loading
    this.cadastrosDoDia = [];
    this.recadastramentosDoDia = [];
    this.registrosUnificados = [];
    this.totalCadastros = 0;
    this.totalRecadastros = 0;
    this.realizadosCadastros = 0;
    this.realizadosRecadastros = 0;

    // Paginação dinâmica
    const pagina = this.paginaAtualRegistros;
    const tamanhoPagina = this.tamanhoPaginaRegistros;
    this.servicoService.obterTodosRegistrosPorPeriodo(usuarioId, dataInicio, dataFim, pagina, tamanhoPagina)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe({
        next: (response: any) => {

          if (response && Array.isArray(response.itens) && response.itens.length > 0) {
            // NOVO: Se cada item já é um registro individual (sem cadastros/recadastros arrays)
            const isFlatList = !response.itens[0].cadastros && !response.itens[0].recadastros;
            if (isFlatList) {
              // Adiciona tipo conforme o id
              this.registrosUnificados = response.itens.map((item: any) => {
                let tipo = 'cadastro';
                if (item.recadastroId && item.recadastroId !== '00000000-0000-0000-0000-000000000000') {
                  tipo = 'recadastro';
                }
                return { ...item, tipo };
              });
              this.cadastrosDoDia = this.registrosUnificados.filter(r => r.tipo === 'cadastro');
              this.recadastramentosDoDia = this.registrosUnificados.filter(r => r.tipo === 'recadastro');
              this.totalCadastros = this.cadastrosDoDia.length;
              this.totalRecadastros = this.recadastramentosDoDia.length;
              this.realizadosCadastros = this.cadastrosDoDia.filter((r: any) => r.dataHoraFim).length;
              this.realizadosRecadastros = this.recadastramentosDoDia.filter((r: any) => r.dataHoraFim).length;

              // Ordenar por data de conclusão (mais recentes primeiro)
              this.registrosUnificados.sort((a, b) => {
                const dataA = new Date(a.dataHoraFim || a.dataRecadastramento || '').getTime();
                const dataB = new Date(b.dataHoraFim || b.dataRecadastramento || '').getTime();
                if (isNaN(dataA) && isNaN(dataB)) return 0;
                if (isNaN(dataA)) return 1;
                if (isNaN(dataB)) return -1;
                return dataB - dataA;
              });

              this.paginaAtualRegistros = response.paginaAtual || 1;
              this.tamanhoPaginaRegistros = response.tamanhoPagina || 100;
              this.totalPaginasRegistros = response.totalPaginas || 1;
              this.totalItensRegistros = response.totalItens || this.registrosUnificados.length;
              this.tempoMedioExecucao = this.formatTempo(response.tempoMedioConclusao || '00:00:00');

              // after populating registros, try auto-opening any pending id from query params
              this.tryAutoOpenPending();
              // Atualiza contadores por status
              this.updateStatusCounters();

            } else {
              // Formato antigo: processar cadastros e recadastros do primeiro item
              const item = response.itens[0];
              const cadastros = (item.cadastros || []).map((c: any) => ({ ...c, tipo: 'cadastro' }));
              const recadastros = (item.recadastros || []).map((r: any) => ({ ...r, tipo: 'recadastro' }));
              this.registrosUnificados = [...cadastros, ...recadastros];

              this.cadastrosDoDia = cadastros;
              this.recadastramentosDoDia = recadastros;
              this.totalCadastros = cadastros.length;
              this.totalRecadastros = recadastros.length;
              this.realizadosCadastros = cadastros.filter((r: any) => r.dataHoraFim).length;
              this.realizadosRecadastros = recadastros.filter((r: any) => r.dataHoraFim).length;

              // Ordenar por data de conclusão (mais recentes primeiro)
              this.registrosUnificados.sort((a, b) => {
                const dataA = new Date(a.dataHoraFim || '').getTime();
                const dataB = new Date(b.dataHoraFim || '').getTime();
                if (isNaN(dataA) && isNaN(dataB)) return 0;
                if (isNaN(dataA)) return 1;
                if (isNaN(dataB)) return -1;
                return dataB - dataA;
              });

              // Paginação
              this.paginaAtualRegistros = response.paginaAtual || 1;
              this.tamanhoPaginaRegistros = response.tamanhoPagina || 100;
              this.totalPaginasRegistros = response.totalPaginas || 1;
              this.totalItensRegistros = response.totalItens || this.registrosUnificados.length;

              // Tempo médio formatado
              this.tempoMedioExecucao = this.formatTempo(item.tempoMedioConclusao || '00:00:00');

              // after populating registros, try auto-opening any pending id from query params
              this.tryAutoOpenPending();
              // Atualiza contadores por status
              this.updateStatusCounters();
            }
            } else {
            // Resposta inesperada
            this.registrosUnificados = [];
            this.cadastrosDoDia = [];
            this.recadastramentosDoDia = [];
            this.totalCadastros = 0;
            this.totalRecadastros = 0;
            this.realizadosCadastros = 0;
            this.realizadosRecadastros = 0;
            this.paginaAtualRegistros = 1;
            this.tamanhoPaginaRegistros = 100;
            this.totalPaginasRegistros = 1;
            this.totalItensRegistros = 0;
            this.tempoMedioExecucao = '00:00:00';
          }
        },
        error: (error) => {
          console.error('Erro ao carregar registros do dia:', error);
          this.cadastrosDoDia = [];
          this.recadastramentosDoDia = [];
          this.registrosUnificados = [];
          this.totalCadastros = 0;
          this.totalRecadastros = 0;
          this.realizadosCadastros = 0;
          this.realizadosRecadastros = 0;
        }
      });
  }

  fecharFormulario() {
    this.mostrarFormulario = false;
    this.CadastroSelecionado = null;
    if (this.mapCadastro) {
      this.mapCadastro.remove();
      this.mapCadastro = null;
    }
  }

  abrirFormulario(cadastro: CriarRecadastramentoResponseDto & { tipo: string }) {
    // Explicit cast via unknown to convert the type as intended
    this.CadastroSelecionado = cadastro as unknown as (CriarCadastroResponseDtoAdmin & { tipo: string });
    this.mostrarFormulario = true;

    setTimeout(() => {
      const formElement = document.querySelector('.form-cadastro-container');
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Inicializar o mapa após o DOM estar pronto
      this.initCadastroMap();
    }, 500); // Aumentei o tempo para garantir que o DOM esteja pronto
  }

  getEmpresaNome(empresa: any): string {
    if (!empresa) return 'N/A';
    if (typeof empresa === 'object' && empresa.nomeDaEmpresa) {
      return empresa.nomeDaEmpresa;
    }
    if (typeof empresa === 'string') {
      return empresa;
    }
    return 'N/A';
  }

  loadUserData() {
    if (!this.filtroUsuarioId) return;

    this.controllAppService.usuarioGetById(this.filtroUsuarioId).subscribe({
      next: (data) => {
        if (data) {
          this.userData = data;
          this.fotoPerfil = data.fotoUrl ? `${environment.mediaUrl}/${data.fotoUrl}` : '';
        }
      },
      error: (error) => {
        console.error('Erro ao carregar dados do usuário:', error);
        this.userData = null;
        this.fotoPerfil = '';
      }
    });
  }

  getImageUrl(path: string | undefined): string {
    if (!path) return '';
    const cleanPath = path.startsWith('/') ? path.substring(1) : path;
    return `${environment.apiBaseUrl}/${cleanPath}`;
  }

  /**
   * Resolve various possible image representations to a full URL string.
   * Accepts a string (relative path), or an object with `.url` property, or undefined.
   */
  getSafeImageUrl(input: any): string {
    if (!input) return '';
    if (typeof input === 'string') return this.getFullImageUrl(input);
    if (typeof input === 'object' && input.url) return this.getFullImageUrl(input.url);
    return '';
  }

  /**
   * Helper to open modal from a value that may be string or object with `.url`.
   */
  openImageFrom(input: any): void {
    const url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');
    if (url) {
      this.abrirModalFoto(this.getFullImageUrl(url));
    }
  }

  formatDateTime(date: string | undefined): string {
    if (!date) return '';
    return new Date(date).toLocaleString();
  }

  // Add method to format time string to HH:mm:ss format
  private formatTempo(tempo: string): string {
    if (!tempo) return '00:00:00';

    // Remove milissegundos se houver
    if (tempo.includes('.')) {
      tempo = tempo.split('.')[0];
    }

    // Se já está no formato hh:mm:ss
    if (/^\d{2}:\d{2}:\d{2}$/.test(tempo)) {
      return tempo;
    }

    // Se vier como string numérica (ex: "12345"), tenta converter para segundos
    if (/^\d+$/.test(tempo)) {
      let totalSeconds = parseInt(tempo, 10);
      const hours = Math.floor(totalSeconds / 3600).toString().padStart(2, '0');
      totalSeconds = totalSeconds % 3600;
      const minutes = Math.floor(totalSeconds / 60).toString().padStart(2, '0');
      const seconds = (totalSeconds % 60).toString().padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    }

    // Se vier como hh:mm:ss.0000000
    const match = tempo.match(/(\d{2}:\d{2}:\d{2})/);
    if (match) {
      return match[1];
    }

    // Fallback
    return '00:00:00';
  }

  openPhotoPreview(imageUrl: string, index: number, type: 'local' | 'documento'): void {
    this.fotoSelecionada = this.getImageUrl(imageUrl);
    this.mostrarModalFoto = true;
  }
  /** Get current rotation for photo (degrees) */
  getPhotoRotation(url: string | undefined): number {
    if (!url) return 0;
    return this.photoRotations[url] || 0;
  }

  private initCadastroMap() {
    // Primeiro verifica se o mapa já existe e o remove para evitar duplicação
    if (this.mapCadastro) {
      this.mapCadastro.remove();
      this.mapCadastro = null;
    }

    // Verifica se o elemento DOM existe e se temos coordenadas
    const mapElement = document.getElementById('mapCadastro');
    if (!mapElement || !this.CadastroSelecionado?.latitudeInicio || !this.CadastroSelecionado?.longitudeInicio) {
      console.warn('Não foi possível inicializar o mapa do cadastro: elemento não encontrado ou coordenadas ausentes');
      return;
    }

    try {
      // Inicializar o mapa
      this.mapCadastro = L.map('mapCadastro').setView([0, 0], 15);

      // Adicionar camada de tiles do OpenStreetMap
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '© OpenStreetMap contributors'
      }).addTo(this.mapCadastro);

      // Criar bounds para ajustar o zoom
      const bounds = L.latLngBounds([]);

      // Adicionar marcador para posição inicial
      if (this.CadastroSelecionado.latitudeInicio && this.CadastroSelecionado.longitudeInicio) {
        const latInicio = parseFloat(this.CadastroSelecionado.latitudeInicio);
        const lngInicio = parseFloat(this.CadastroSelecionado.longitudeInicio);

        if (!isNaN(latInicio) && !isNaN(lngInicio)) {
          // Usar ícone de imagem para o início
          const inicioIcon = L.icon({
            iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoInicio.png',
            iconSize: [48, 48],        // ícone aumentado
            iconAnchor: [24, 48],
            popupAnchor: [0, -45]
          });

          // Adicionar o marcador de início
          const inicioMarker = L.marker([latInicio, lngInicio], {
            icon: inicioIcon
          }).addTo(this.mapCadastro);

          // Adicionar popup com informações
          const dataInicio = this.CadastroSelecionado.dataHoraInicio
            ? new Date(this.CadastroSelecionado.dataHoraInicio).toLocaleString()
            : 'Data não disponível';

          inicioMarker.bindPopup(`
            <strong>Início do Cadastro</strong><br>
            Data/Hora: ${dataInicio}<br>
            Coord: ${latInicio.toFixed(6)}, ${lngInicio.toFixed(6)}
          `);

          // Estender os bounds
          bounds.extend([latInicio, lngInicio]);
        }
      }

      // Adicionar marcador para posição final (se disponível)
      if (this.CadastroSelecionado.latitudeFim && this.CadastroSelecionado.longitudeFim) {
        let latFim = parseFloat(this.CadastroSelecionado.latitudeFim);
        let lngFim = parseFloat(this.CadastroSelecionado.longitudeFim);

        // Se as coordenadas forem praticamente iguais, deslocar ligeiramente
        if (Math.abs(latFim - parseFloat(this.CadastroSelecionado.latitudeInicio)) < 0.00001 &&
          Math.abs(lngFim - parseFloat(this.CadastroSelecionado.longitudeInicio)) < 0.00001) {
          const offset = 0.0001;
          latFim += offset;
          lngFim += offset;
        }

        if (!isNaN(latFim) && !isNaN(lngFim)) {
          // Usar ícone de imagem para o fim
          const fimIcon = L.icon({
            iconUrl: 'https://cedae.homologacao.vibetex.com.br/images/marcacaoFim.png',
            iconSize: [48, 48],       // ícone aumentado
            iconAnchor: [24, 48],
            popupAnchor: [0, -45]
          });

          // Adicionar o marcador de fim
          const fimMarker = L.marker([latFim, lngFim], {
            icon: fimIcon
          }).addTo(this.mapCadastro);

          // Adicionar popup com informações
          const dataFim = this.CadastroSelecionado.dataHoraFim
            ? new Date(this.CadastroSelecionado.dataHoraFim).toLocaleString()
            : 'Data não disponível';

          fimMarker.bindPopup(`
            <strong>Fim do Cadastro</strong><br>
            Data/Hora: ${dataFim}<br>
            Coord: ${latFim.toFixed(6)}, ${lngFim.toFixed(6)}
          `);

          // Estender os bounds
          bounds.extend([latFim, lngFim]);

          // Desenhar uma linha entre os pontos de início e fim
          if (bounds.isValid() && bounds.getNorthEast().lat !== bounds.getSouthWest().lat) {
            const linha = L.polyline([
              [parseFloat(this.CadastroSelecionado.latitudeInicio), parseFloat(this.CadastroSelecionado.longitudeInicio)],
              [latFim, lngFim]
            ], {
              color: '#3388ff',
              weight: 3,
              opacity: 0.5,
              dashArray: '10, 10'
            }).addTo(this.mapCadastro);
          }
        }
      }

      // Ajustar o mapa para mostrar todos os pontos
      if (bounds.isValid()) {
        this.mapCadastro.fitBounds(bounds, {
          padding: [50, 50],
          maxZoom: 18
        });
      } else if (this.CadastroSelecionado.latitudeInicio && this.CadastroSelecionado.longitudeInicio) {
        // Se não temos bounds válidos mas temos coordenadas de início, centralizar nelas
        const lat = parseFloat(this.CadastroSelecionado.latitudeInicio);
        const lng = parseFloat(this.CadastroSelecionado.longitudeInicio);
        this.mapCadastro.setView([lat, lng], 15);
      }

      // Forçar atualização do tamanho do mapa
      setTimeout(() => {
        if (this.mapCadastro) {
          this.mapCadastro.invalidateSize();
        }
      }, 200);

    } catch (error) {
      console.error('Erro ao inicializar o mapa do cadastro:', error);
    }
  }
  getTipoServico(registro: any): string {
    // Usa o mesmo método para determinar o tipo de serviço
    return this.determinarTipoServico(registro);
  }
  private determinarTipoServico(item: any): string {
    // Se tem recadastroId e não é o UUID vazio, é recadastro
    if (item.recadastroId && item.recadastroId !== "00000000-0000-0000-0000-000000000000") {
      return 'recadastro';
    }
    // Caso contrário é cadastro
    return 'cadastro';
  }

  maskCpf(cpf: string): string {
    if (!cpf) return '-';
    cpf = cpf.replace(/\D/g, '');
    if (cpf.length !== 11) return cpf;
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  maskCnpj(cnpj: any): string {
    if (!cnpj) return '-';
    cnpj = String(cnpj).replace(/\D/g, '');
    if (cnpj.length !== 14) return cnpj;
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  maskTelefone(telefone: string): string {
    if (!telefone) return '-';
    telefone = telefone.replace(/\D/g, '');
    if (telefone.length === 11) {
      return telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
    if (telefone.length === 10) {
      return telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }
    return telefone;
  }
  private displayUserLocationsForDate(user: UsuarioResponseDto) {
    this.isLoadingMap = true;
    this.shiftMarkers.forEach(marker => this.mapShiftLocation.removeLayer(marker));
    this.shiftMarkers = [];
    this.shiftPolylines.forEach(polyline => this.mapShiftLocation.removeLayer(polyline));
    this.shiftPolylines = [];

    if (!this.filtroUsuarioId) {
      this.isLoadingMap = false;
      return;
    }

    this.roteiroUsuarioService.obterLocalizacoesPorUsuario(this.filtroUsuarioId).subscribe({
      next: (localizacoes: Localizacao[]) => {
        const dataInicio = this.filtroDataInicio;
        const dataFim = this.filtroDataFim;

        // Filtrar pelo período selecionado
        const locationsForPeriod = localizacoes.filter(loc => {
          if (!loc.dataHora) return false;
          const data = new Date(loc.dataHora);
          const dataStr = data.toISOString().split('T')[0];
          return dataStr >= dataInicio && dataStr <= dataFim;
        }).sort((a, b) => new Date(a.dataHora).getTime() - new Date(b.dataHora).getTime());

        // Preencher as datas disponíveis para o select
        this.datasDisponiveisMapa = Array.from(
          new Set(locationsForPeriod.map(loc => new Date(loc.dataHora).toISOString().split('T')[0]))
        ).sort((a, b) => a.localeCompare(b));

        // Se não houver data selecionada ou ela não está na lista, selecionar a primeira disponível
        if (!this.dataSelecionadaMapa || !this.datasDisponiveisMapa.includes(this.dataSelecionadaMapa)) {
          this.dataSelecionadaMapa = this.datasDisponiveisMapa[0] || '';
        }

        // Filtrar localizações apenas para o dia selecionado no select
        const locationsForDay = locationsForPeriod.filter(loc => {
          const dataStr = new Date(loc.dataHora).toISOString().split('T')[0];
          return dataStr === this.dataSelecionadaMapa;
        });

        const uniqueLocations = this.filterUniqueLocations(locationsForDay);
        if (uniqueLocations.length === 0) {
          this.isLoadingMap = false;
          return;
        }

        const bounds = L.latLngBounds([]);
        const validLocations = uniqueLocations.filter(loc => {
          const lat = parseFloat(loc.latitude || '0');
          const lng = parseFloat(loc.longitude || '0');
          return !isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
        });

        const points: [number, number][] = [];
        const latLngs: { lat: number, lng: number, index: number, dataHora: string }[] = [];
        validLocations.forEach((loc, index) => {
          const lat = parseFloat(loc.latitude);
          const lng = parseFloat(loc.longitude);
          points.push([lat, lng]);
          latLngs.push({ lat, lng, index, dataHora: loc.dataHora });
        });
        // Adiciona todos os marcadores, exceto o último
        for (let i = 0; i < latLngs.length - 1; i++) {
          const item = latLngs[i];
          this.addLocationMarker(item.lat, item.lng, item.index + 1, item.dataHora, bounds, false);
        }
        // Adiciona o último marcador por último (para ficar "na frente")
        if (latLngs.length > 0) {
          const last = latLngs[latLngs.length - 1];
          this.addLocationMarker(last.lat, last.lng, last.index + 1, last.dataHora, bounds, true);
        }

        this.routeRequestQueue = [];
        for (let i = 0; i < points.length - 1; i++) {
          const start = points[i];
          const end = points[i + 1];
          const distance = this.calculateDistance(start[0], start[1], end[0], end[1]);
          if (distance < 0.01) {
            this.createSimpleRoute(start, end);
            continue;
          }
          this.routeRequestQueue.push(() => {
            this.createRouteBetweenPoints(start, end, i + 1);
          });
        }
        this.processRouteQueue();
        if (bounds.isValid()) {
          this.mapShiftLocation.fitBounds(bounds, { padding: [30, 30] });
        }
        setTimeout(() => {
          this.isLoadingMap = false;
        }, 1000);
      },
      error: (error: any) => {
        this.isLoadingMap = false;
      }
    });
  }

  // Novo método para trocar o dia selecionado no select do mapa
  onChangeDataMapa(novaData: string) {
    this.dataSelecionadaMapa = novaData;
    // Recarrega o mapa apenas para o dia selecionado
    if (this.userData) {
      this.displayUserLocationsForDate(this.userData);
    }
  }

  private calculateDistance(lat1: number, lon1: number, lat2: number, lon2: number): number {
    const R = 6371; // Radius of the earth in km
    const dLat = this.deg2rad(lat2 - lat1);
    const dLon = this.deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  }

  private deg2rad(deg: number): number {
    return deg * (Math.PI / 180);
  }

  // Add method to process route requests with rate limiting
  private async processRouteQueue(): Promise<void> {
    if (this.isProcessingRoutes || this.routeRequestQueue.length === 0) {
      return;
    }

    this.isProcessingRoutes = true;

    while (this.routeRequestQueue.length > 0) {
      const request = this.routeRequestQueue.shift();
      if (request) {
        request();
        // Wait before processing next request
        await new Promise(resolve => setTimeout(resolve, this.routeRequestDelay));
      }
    }

    this.isProcessingRoutes = false;
  }

  private createRouteBetweenPoints(start: [number, number], end: [number, number], sequenceNumber: number) {
    const startPoint = `${start[1]},${start[0]}`;
    const endPoint = `${end[1]},${end[0]}`;

    // Check if start and end points are the same
    if (start[0] === end[0] && start[1] === end[1]) {
      console.warn('Start and end points are the same, skipping route creation');
      return;
    }

    if (!this.mapShiftLocation) {
      console.error('mapShiftLocation is undefined. Cannot add route.');
      return;
    }

    // Exibir um indicador de carregamento temporário
    const loadingDiv = L.divIcon({
      html: `<div style="color: #3388ff; font-weight: bold;">⟳</div>`,
      className: 'loading-icon',
      iconSize: [20, 20]
    });

    const loadingMarker = L.marker([(start[0] + end[0]) / 2, (start[1] + end[1]) / 2], {
      icon: loadingDiv,
      interactive: false
    }).addTo(this.mapShiftLocation);

    // Add timeout and better error handling
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000); // 10 second timeout

    // Buscar a rota real do serviço OSRM with rate limiting
    fetch(`https://router.project-osrm.org/route/v1/driving/${startPoint};${endPoint}?overview=full&geometries=geojson`, {
      signal: controller.signal,
      headers: {
        'User-Agent': 'VibetexApp/1.0'
      }
    })
      .then(response => {
        clearTimeout(timeoutId);

        if (response.status === 429) {
          throw new Error('Rate limited - too many requests');
        }

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
      })
      .then(data => {
        // Remover o indicador de carregamento
        this.mapShiftLocation.removeLayer(loadingMarker);

        if (data.routes && data.routes[0] && data.routes[0].geometry) {
          const route = data.routes[0];
          const coordinates: L.LatLngExpression[] = [];

          // Extrair coordenadas do GeoJSON (formato [lng, lat])
          if (route.geometry && route.geometry.coordinates) {
            route.geometry.coordinates.forEach((coord: number[]) => {
              // Converter para formato Leaflet [lat, lng]
              coordinates.push([coord[1], coord[0]]);
            });
          }

          if (coordinates.length > 0) {
            // Criar a polyline para a rota
            const routeLine = L.polyline(coordinates, {
              color: '#3388ff',
              weight: 4,
              opacity: 0.7,
              className: 'route-line'
            }).addTo(this.mapShiftLocation);

            // Adicionar setas de direção ao longo da rota (only for longer routes)
            if (coordinates.length > 10) {
              this.addDirectionArrows(routeLine, coordinates);
            }

            this.shiftPolylines.push(routeLine);
          }
        } else {
          // Fallback: usar linha reta se a rota não estiver disponível
          console.warn('No route data available, using straight line');
          this.createSimpleRoute(start, end);
        }
      })
      .catch(error => {
        clearTimeout(timeoutId);
        // Remover o indicador de carregamento
        this.mapShiftLocation.removeLayer(loadingMarker);

        // Fallback: usar linha reta em caso de erro
        this.createSimpleRoute(start, end);
      });
  }

  private addDirectionArrows(routeLine: L.Polyline, coordinates: L.LatLngExpression[]) {
    if (!this.mapShiftLocation) {
      console.error('mapShiftLocation is undefined. Cannot add direction arrows.');
      return;
    }
    if (!coordinates || coordinates.length < 2) return;

    // Check if Math object is available
    if (typeof Math === 'undefined') {
      console.error('Math object is undefined. Cannot add direction arrows.');
      return;
    }

    // Adicionar setas em pontos estratégicos da rota
    const arrowPositions = [0.5]; // Posição relativa na rota (meio)

    arrowPositions.forEach(position => {
      const pointIndex = (typeof Math !== 'undefined')
        ? Math.floor(coordinates.length * position)
        : parseInt((coordinates.length * position).toString(), 10);
      if (pointIndex >= coordinates.length - 1) return;

      // Função utilitária para normalizar para [number, number]
      const toLatLngArr = (coord: L.LatLngExpression): [number, number] => {
        if (Array.isArray(coord)) return [coord[0], coord[1]];
        if ('lat' in (coord as any) && 'lng' in (coord as any)) return [(coord as any).lat, (coord as any).lng];
        if (coord instanceof L.LatLng) return [coord.lat, coord.lng];
        return [0, 0];
      };

      const point = toLatLngArr(coordinates[pointIndex]);

      // Safe calculation for next point index
      const nextIndex = (typeof Math !== 'undefined')
        ? Math.min(pointIndex + 1, coordinates.length - 1)
        : (pointIndex + 1 < coordinates.length ? pointIndex + 1 : coordinates.length - 1);

      const nextPoint = toLatLngArr(coordinates[nextIndex]);

      // Calcular ângulo da direção - with safety check
      const angle = (typeof Math !== 'undefined')
        ? Math.atan2(
          nextPoint[0] - point[0],
          nextPoint[1] - point[1]
        ) * 180 / Math.PI
        : 0;

      // Criar seta
      const arrowIcon = L.divIcon({
        html: `<div style="transform: rotate(${angle}deg);">➤</div>`,
        className: 'route-arrow',
        iconSize: [20, 20],
        iconAnchor: [10, 10]
      });

      // Adicionar a seta
      const arrowMarker = L.marker(point, {
        icon: arrowIcon,
        interactive: false
      }).addTo(this.mapShiftLocation);

      this.shiftMarkers.push(arrowMarker);
    });
  }

  private createSimpleRoute(start: [number, number], end: [number, number]) {
    if (!this.mapShiftLocation) {
      console.error('mapShiftLocation is undefined. Cannot add simple route.');
      return;
    }

    // Check if parameters are valid
    if (!start || !end || start.length !== 2 || end.length !== 2) {
      console.error('Invalid start or end coordinates for simple route.');
      return;
    }

    // Check if Math object is available
    if (typeof Math === 'undefined') {
      console.error('Math object is undefined. Cannot create simple route.');
      return;
    }

    // Usar linha reta como fallback
    const routeLine = L.polyline([start, end], {
      color: '#3388ff',
      opacity: 0.6,
      dashArray: '5, 10'
    }).addTo(this.mapShiftLocation);

    // Adicionar tooltip para explicar
    routeLine.bindTooltip('Rota aproximada', {
      permanent: false,
      direction: 'center',
      className: 'route-tooltip'
    });

    this.shiftPolylines.push(routeLine);
  }

  private filterUniqueLocations(locations: any[]): any[] {
    if (!locations || locations.length === 0) return [];
    const uniqueLocations = [];
    const seen = new Set<string>();

    // Normaliza coordenadas para 4 casas decimais
    const normalizeCoord = (coord: string): string => {
      if (!coord) return '0.0000';
      return Number(coord).toFixed(4);
  };

    for (const loc of locations) {
      const lat = normalizeCoord(loc.latitude);

  
      const lng = normalizeCoord(loc.longitude);
      const dataHora = loc.dataHora ? new Date(loc.dataHora) : null;

      if (isNaN(Number(lat)) || isNaN(Number(lng)) || Number(lat) === 0 || Number(lng) === 0 || !dataHora) {
        console.warn(`Ignorando coordenada inválida: ${loc.latitude}, ${loc.longitude}, ${loc.dataHora}`);
        continue;
      }

      // Chave: lat|lng|hh:mm
      const horaMinuto = dataHora.toTimeString().slice(0, 5); // "HH:MM"
      const key = `${lat}|${lng}|${horaMinuto}`;

      if (!seen.has(key)) {
        uniqueLocations.push(loc);
        seen.add(key);
      }
    }

    return uniqueLocations;
  }

  /**
   * Atualiza os contadores de status (cadastro / recadastro) baseado em `registrosUnificados`.
   * Conta por tipo e statusOS.
   */
  private updateStatusCounters(): void {
    // reset
    this.cadastroConcluida = 0;
    this.cadastroRetornar = 0;
    this.cadastroNegada = 0;
    this.recadastroConcluida = 0;
    this.recadastroRetornar = 0;
    this.recadastroNegada = 0;
    this.pendingBothCount = 0;

    if (!this.registrosUnificados || !Array.isArray(this.registrosUnificados)) {
      return;
    }

    for (const r of this.registrosUnificados) {
      const statusOS = (r && r.statusOS) ? String(r.statusOS).trim() : '';
      const tipo = (r && r.tipo) ? String(r.tipo).trim() : '';

      if (tipo === 'cadastro') {
        if (statusOS === 'Concluida') this.cadastroConcluida += 1;
        else if (statusOS === 'Retornar') this.cadastroRetornar += 1;
        else if (statusOS === 'Negada') this.cadastroNegada += 1;
      } else if (tipo === 'recadastro') {
        if (statusOS === 'Concluida') this.recadastroConcluida += 1;
        else if (statusOS === 'Retornar') this.recadastroRetornar += 1;
        else if (statusOS === 'Negada') this.recadastroNegada += 1;
      }

      // Contar pendentes (qualquer statusOS que não seja concludente)
      if (statusOS === 'Pendente' || statusOS === 'EmAndamento') {
        this.pendingBothCount += 1;
      }
    }

    // Agrupa os totais exibidos nos cards principais (Cadastro / Recadastro)
    this.cadastroStatusTotal = this.cadastroConcluida + this.cadastroRetornar + this.cadastroNegada;
    this.recadastroStatusTotal = this.recadastroConcluida + this.recadastroRetornar + this.recadastroNegada;
  }

  private addLocationMarker(lat: number, lng: number, position: number, dataHora: string, bounds: L.LatLngBounds, isLast: boolean = false) {
    if (isNaN(lat) || isNaN(lng) || lat === 0 || lng === 0) {
      console.error(`Tentativa de adicionar marcador com coordenadas inválidas: ${lat}, ${lng}`);
      return;
    }

    const icon = L.divIcon({
      className: '',
      html: this.generateMarkerSvg(position),
      iconSize: [36, 50],
      iconAnchor: [18, 50],
      popupAnchor: [0, -45]
    });

    const marker = L.marker([lat, lng], {
      icon,
      title: `Ponto ${position}`,
      zIndexOffset: isLast ? 1000 : position // O último marcador terá z-index muito alto
    }).addTo(this.mapShiftLocation);

    const time = new Date(dataHora).toLocaleTimeString();
    const date = new Date(dataHora).toLocaleDateString();

    marker.bindPopup(`
      <strong>Ponto ${position}</strong><br>
      Data: ${date}<br>
      Hora: ${time}<br>
      Coord: ${lat.toFixed(6)}, ${lng.toFixed(6)}
    `);

    this.shiftMarkers.push(marker);
    bounds.extend([lat, lng]);
  }

  // Métodos para paginação da tabela de registros por período
  mudarPaginaRegistros(pagina: number) {
    if (pagina < 1 || pagina > this.totalPaginasRegistros) return;
    this.paginaAtualRegistros = pagina;
    this.carregarCadastrosDoDia();
  }

  mudarTamanhoPaginaRegistros(tamanho: number) {
    if (tamanho < 1) return;
    this.tamanhoPaginaRegistros = tamanho;
    this.paginaAtualRegistros = 1;
    this.carregarCadastrosDoDia();
  }

  /**
   * Exporta os dados filtrados da tabela para Excel
   * Com título "Relatório de Vistorias" e logos
   * Busca TODOS os registros do período atual
   */
  async exportarParaExcel(): Promise<void> {
    try {
      this.spinner.show();

      // Determina os registros a serem exportados (aplica filtro de status se houver)
      const registrosParaExportar = (this.registrosFiltrados && this.registrosFiltrados.length > 0)
        ? this.registrosFiltrados
        : this.registrosUnificados;

      // Se não houver registros, mostra mensagem e cancela
      if (!registrosParaExportar || registrosParaExportar.length === 0) {
        this.spinner.hide();
        alert('Nenhum registro encontrado para exportar.');
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Relatório');

      // Função auxiliar para baixar imagem e converter para base64
      const getImageBase64 = async (url: string): Promise<string | null> => {
        try {
          const response = await fetch(url);
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64 = reader.result as string;
              resolve(base64.split(',')[1]);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          console.error('Erro ao carregar imagem:', url, error);
          return null;
        }
      };

      // Baixa as imagens dos logos
      const [logoCedaeBase64, logoVibetexBase64] = await Promise.all([
        getImageBase64('https://cedae.vibetex.com.br/images/cedae2.jpg'),
        getImageBase64('https://cedae.vibetex.com.br/images/logo_vibetex.png')
      ]);

      let imagemCedaeId: number | null = null;
      let imagemVibetexId: number | null = null;

      if (logoCedaeBase64) {
        imagemCedaeId = workbook.addImage({
          base64: logoCedaeBase64,
          extension: 'jpeg',
        });
      }

      if (logoVibetexBase64) {
        imagemVibetexId = workbook.addImage({
          base64: logoVibetexBase64,
          extension: 'png',
        });
      }

      // Linha 1: Título
      worksheet.mergeCells('C1:L1');
      const titleCell = worksheet.getCell('C1');
      titleCell.value = 'Relatório de Vistorias - Roteiro do Colaborador';
      titleCell.font = { bold: true, size: 14, color: { argb: 'FFFFFFFF' } };
      titleCell.alignment = { vertical: 'middle', horizontal: 'center' };
      titleCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      worksheet.getRow(1).height = 50;

      if (imagemVibetexId !== null) {
        worksheet.addImage(imagemVibetexId, {
          tl: { col: 2.1, row: 0.1 },
          ext: { width: 60, height: 55 }
        });
      }

      if (imagemCedaeId !== null) {
        worksheet.addImage(imagemCedaeId, {
          tl: { col: 11.55, row: 0.1 },
          ext: { width: 60, height: 55 }
        });
      }

      worksheet.addRow([]);

      worksheet.mergeCells('C3:L3');
      const cadastroRow = worksheet.getRow(3);
      cadastroRow.getCell('C').value = 'Cadastro / Recadastro';
      cadastroRow.getCell('C').font = { bold: true, size: 11, color: { argb: 'FFFFFFFF' } };
      cadastroRow.getCell('C').alignment = { vertical: 'middle', horizontal: 'center' };
      cadastroRow.getCell('C').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF0062CC' }
      };
      cadastroRow.height = 20;

      worksheet.addRow([]);

      worksheet.getColumn(1).width = 3;
      worksheet.getColumn(2).width = 3;
      worksheet.getColumn(3).width = 6;   // #
      worksheet.getColumn(4).width = 30;  // ENDEREÇO
      worksheet.getColumn(5).width = 8;   // Nº
      worksheet.getColumn(6).width = 25;  // MUNICÍPIO
      worksheet.getColumn(7).width = 23;  // BAIRRO
      worksheet.getColumn(8).width = 19;  // SERVIÇO EXECUTADO
      worksheet.getColumn(9).width = 15;  // Nº VISTORIA
      worksheet.getColumn(10).width = 12; // DATA
      worksheet.getColumn(11).width = 12; // STATUS
      worksheet.getColumn(12).width = 15; // CONFORMIDADE

      const headerRow = worksheet.getRow(5);
      headerRow.values = ['', '', '#', 'ENDEREÇO', 'Nº', 'MUNICÍPIO', 'BAIRRO', 'SERVIÇO EXECUTADO', 'Nº VISTORIA', 'DATA', 'STATUS', 'CONFORMIDADE'];
      headerRow.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      headerRow.alignment = { vertical: 'middle', horizontal: 'center' };
      headerRow.height = 25;

      for (let col = 3; col <= 12; col++) {
        headerRow.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FF0062CC' }
        };
      }

      registrosParaExportar.forEach((servico, index) => {
        const servicoAny = servico as any; // Para acessar propriedades dinâmicas
        let logradouroTipo = '';
        let logradouroNome = '';
        let enderecoCompleto = '';
        let numero = '';
        let municipio = '';
        let bairro = '';

        if (servico.endereco) {
          const enderecoAny = servico.endereco as any;
          logradouroTipo = enderecoAny.logradouroTipo ||
            enderecoAny.tipoLogradouro ||
            enderecoAny.tipo ||
            enderecoAny.tipoEndereco || '';

          logradouroNome = servico.endereco.logradouro ||
            enderecoAny.nomeLogradouro ||
            enderecoAny.nome ||
            enderecoAny.rua || '';

          numero = servico.endereco.numero ||
            enderecoAny.numeroEndereco ||
            enderecoAny.numeroLogradouro || '';

          municipio = servico.endereco.cidade ||
            servico.endereco.localidade ||
            enderecoAny.municipio ||
            enderecoAny.nomeMunicipio || '';

          bairro = servico.endereco.bairro ||
            enderecoAny.nomeBairro || '';
        }

        // Fallback: tenta campos diretos no objeto principal
        if (!logradouroTipo) {
          logradouroTipo = servicoAny.logradouroTipo ||
            servicoAny.tipoLogradouro ||
            servicoAny.tipo || '';
        }

        if (!logradouroNome) {
          logradouroNome = servicoAny.logradouro ||
            servicoAny.nomeLogradouro ||
            servicoAny.rua || '';
        }

        if (!numero) {
          numero = servicoAny.numero ||
            servicoAny.numeroEndereco ||
            servicoAny.numeroLogradouro || '';
        }

        if (!municipio) {
          municipio = servicoAny.municipio ||
            servicoAny.cidade ||
            servicoAny.localidade ||
            servicoAny.nomeMunicipio || '';
        }

        if (!bairro) {
          bairro = servicoAny.bairro ||
            servicoAny.nomeBairro || '';
        }

        // Monta o endereço completo
        enderecoCompleto = logradouroTipo && logradouroNome
          ? `${logradouroTipo} ${logradouroNome}`.trim()
          : logradouroNome || logradouroTipo || '';

        // Se não encontrou tipo de logradouro separado, tenta extrair do endereço completo
        if (!logradouroTipo && enderecoCompleto) {
          const tiposLogradouro = ['Rua', 'Avenida', 'Av', 'Travessa', 'Trav', 'Alameda', 'Praça',
            'Rodovia', 'Estrada', 'Largo', 'Viela', 'Beco', 'Conjunto'];

          for (const tipo of tiposLogradouro) {
            const regex = new RegExp(`^${tipo}\\s`, 'i');
            if (regex.test(enderecoCompleto)) {
              logradouroTipo = tipo;
              break;
            }
          }
        }

        let dataFormatada = '';
        const candidatoDataStr = servicoAny.dataServico || servico.dataRecadastramento || servicoAny.dataCadastroOriginal || servico.dataCadastro || servico.dataHoraInicio || servicoAny.dataCriacao || servicoAny.data;
        if (candidatoDataStr) {
          const data = new Date(candidatoDataStr);
          if (!isNaN(data.getTime())) {
            const dia = String(data.getDate()).padStart(2, '0');
            const mes = String(data.getMonth() + 1).padStart(2, '0');
            const ano = data.getFullYear();
            dataFormatada = `${dia}/${mes}/${ano}`;
          } else {
            if (typeof candidatoDataStr === 'string') {
              const m = candidatoDataStr.match(/(\d{4})-(\d{2})-(\d{2})/);
              if (m) {
                dataFormatada = `${m[3]}/${m[2]}/${m[1]}`;
              }
            }
          }
        }

        // Tipo de serviço já vem no objeto
        const tipo = servico.tipo || 'Cadastro';
        const numeroVistoria = this.formatNumeroOS(servico);

        // Define status
        let statusTexto = servico.status || 'Pendente';
        if (servico.statusOS && (servico.status === 'Pendente' || !servico.status)) {
          statusTexto = servico.statusOS;
        }
        
        // Define cores baseadas no status
        let corStatus = 'FF28A745'; // Verde padrão
        if (statusTexto === 'Negado' || statusTexto === 'Negada') {
          corStatus = 'FFDC3545'; // Vermelho
        } else if (statusTexto === 'Pendente' || statusTexto === 'EmAndamento') {
          corStatus = 'FFFFB703'; // Amarelo
        } else if (statusTexto === 'Invalido') {
          corStatus = 'FFDC3545'; // Vermelho
        } else if (statusTexto === 'Validado' || statusTexto === 'Concluido' || statusTexto === 'Concluída') {
          corStatus = 'FF28A745'; // Verde
        } else if (statusTexto === 'Retornar') {
          corStatus = 'FFF6B21A'; // Laranja
        } else if (statusTexto === 'Ausente') {
          corStatus = 'FF6C757D'; // Cinza
        } else if (statusTexto === 'Analisando') {
          corStatus = 'FF0D6EFD'; // Azul
        } else if (statusTexto === 'Cancelada') {
          corStatus = 'FF8A5A5A'; // Marrom
        }

        const isRecadastro = tipo && tipo.toLowerCase().includes('recadastro');
        const corTipo = isRecadastro ? 'FF9C27B0' : 'FF00BCD4';
        const corTextoTipo = 'FFFFFFFF'; // Branco para melhor contraste

        const row = worksheet.addRow([
          '', '', index + 1, enderecoCompleto || '-',
          numero || '-', municipio || '-', bairro || '-', tipo,
          numeroVistoria, dataFormatada || '-', statusTexto, '' // Conformidade vazia para preenchimento manual
        ]);

        // Aplica validação de dados (dropdown) na coluna de Conformidade (coluna 12)
        const conformidadeCell = row.getCell(12);
        conformidadeCell.dataValidation = {
          type: 'list',
          allowBlank: true,
          formulae: ['"Conforme,Não Conforme"'],
          showErrorMessage: true,
          errorStyle: 'error',
          errorTitle: 'Valor Inválido',
          error: 'Por favor, selecione "Conforme" ou "Não Conforme"'
        };
        conformidadeCell.alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
        conformidadeCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFFEF9E7' } // Amarelo claro para indicar preenchimento pendente
        };

        row.getCell(8).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corTipo }
        };
        row.getCell(8).font = {
          color: { argb: corTextoTipo },
          bold: true
        };
        row.getCell(8).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };

        // Aplica cor do status (coluna 11)
        row.getCell(11).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: corStatus }
        };
        row.getCell(11).font = {
          color: { argb: 'FFFFFFFF' },
          bold: true
        };
        row.getCell(11).alignment = {
          vertical: 'middle',
          horizontal: 'center'
        };
      });

      const primeiraLinhaDados = 6;
      const ultimaLinhaDados = 5 + registrosParaExportar.length;

      // Regra 1: Se célula = "Conforme", fundo verde
      worksheet.addConditionalFormatting({
        ref: `L${primeiraLinhaDados}:L${ultimaLinhaDados}`,
        rules: [
          {
            type: 'cellIs',
            operator: 'equal',
            formulae: ['"Conforme"'],
            priority: 1,
            style: {
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF28A745' },
                bgColor: { argb: 'FF28A745' }
              },
              font: {
                color: { argb: 'FFFFFFFF' },
                bold: true
              }
            }
          }
        ]
      });

      // Regra 2: Se célula = "Não Conforme", fundo vermelho
      worksheet.addConditionalFormatting({
        ref: `L${primeiraLinhaDados}:L${ultimaLinhaDados}`,
        rules: [
          {
            type: 'cellIs',
            operator: 'equal',
            formulae: ['"Não Conforme"'],
            priority: 2,
            style: {
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF70000' },
                bgColor: { argb: 'FFF70000' }
              },
              font: {
                color: { argb: 'FFFFFFFF' },
                bold: true
              }
            }
          },
          {
            type: 'cellIs',
            operator: 'equal',
            formulae: ['"Nao Conforme"'],
            priority: 3,
            style: {
              fill: {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FFF70000' },
                bgColor: { argb: 'FFF70000' }
              },
              font: {
                color: { argb: 'FFFFFFFF' },
                bold: true
              }
            }
          }
        ]
      });

      // Aplica bordas
      worksheet.eachRow((row, rowNumber) => {
        row.eachCell((cell, colNumber) => {
          if (colNumber >= 3 && colNumber <= 12) {
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' }
            };

            if (rowNumber > 4) {
              if (colNumber === 3) {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFF8F9FA' }
                };
                cell.font = { bold: true };
              } else if (colNumber === 4) {
                cell.alignment = { vertical: 'middle', horizontal: 'left' };
              } else {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
              }
            }
          }
        });
      });

      // Estatísticas
      const totalRegistros = registrosParaExportar.length;

      worksheet.addRow([]);

      const rowTotal = worksheet.addRow(['', '', `TOTAL GERAL: ${totalRegistros}`, '', '', '', '', '', '', '', '', '']);
      rowTotal.font = { bold: true, size: 11 };
      for (let col = 3; col <= 12; col++) {
        rowTotal.getCell(col).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFE8F4F8' }
        };
      }
      worksheet.mergeCells(`C${rowTotal.number}:L${rowTotal.number}`);
      const cellRowTotal = rowTotal.getCell('C');
      cellRowTotal.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      rowTotal.height = 22;

      worksheet.addRow([]);

      let dataInicioFormatada = 'N/A';
      let dataFimFormatada = 'N/A';

      if (this.filtroDataInicio) {
        const [ano, mes, dia] = this.filtroDataInicio.split('-');
        dataInicioFormatada = `${dia}/${mes}/${ano}`;
      }

      if (this.filtroDataFim) {
        const [ano, mes, dia] = this.filtroDataFim.split('-');
        dataFimFormatada = `${dia}/${mes}/${ano}`;
      }

      const rowPeriodo = worksheet.addRow(['', '', `Período: ${dataInicioFormatada} até ${dataFimFormatada}`, '', '', '', '', '', '', '', '', '']);

      worksheet.mergeCells(`C${rowPeriodo.number}:L${rowPeriodo.number}`);

      const cellPeriodo = rowPeriodo.getCell('C');
      cellPeriodo.font = {
        bold: true,
        size: 11,
        color: { argb: 'FF0062CC' }
      };
      cellPeriodo.alignment = {
        vertical: 'middle',
        horizontal: 'center'
      };
      cellPeriodo.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFE8F4F8' }
      };
      cellPeriodo.border = {
        top: { style: 'thin', color: { argb: 'FF0062CC' } },
        left: { style: 'thin', color: { argb: 'FF0062CC' } },
        bottom: { style: 'thin', color: { argb: 'FF0062CC' } },
        right: { style: 'thin', color: { argb: 'FF0062CC' } }
      };

      rowPeriodo.height = 25;

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const hoje = new Date();
      const dataArquivo = `${String(hoje.getDate()).padStart(2, '0')}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${hoje.getFullYear()}`;

      const nomeArquivo = `relatorio-roteiro-colaborador_${dataArquivo}.xlsx`;

      saveAs(blob, nomeArquivo);

      this.spinner.hide();
    } catch (error) {
      console.error('Erro ao exportar para Excel:', error);
      this.spinner.hide();
      alert('Erro ao exportar para Excel. Tente novamente.');
    }
  }
}